export const TitumDetails = {
   SOLUTION_BY : "Solution By: bizX by Titum",
   EMAIL_ID: "bizx@titum.lk",
   PHONE_NO: "+94 77 077 6677",
   WEB : "www.titum.lk",
   COMPANY: "Titum Pvt Ltd"
  };
  